<div class="wrapper">
  <mat-card>
    <mat-card-header> <h1>Sign in with</h1></mat-card-header>
    <mat-card-content> </mat-card-content>
    <mat-card-actions class="sign-in__actions">
      <button
        mat-raised-button
        class="sign-in__button"
        (click)="signInWithGoogle()"
        type="button"
      >
        Google
      </button>
      <button
      mat-raised-button
      class="sign-in__button"
      (click)="signInWithGithub()"
      type="button"
    >
      Github
    </button>
    </mat-card-actions>
  </mat-card>
</div>
